import React, { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import DemoApp from './DemoApp';
import HomePage from './pages/HomePage';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'));

function isDemoRoute(pathname) {
  return pathname === '/demo' || pathname.startsWith('/demo/');
}

export default function App() {
  const location = useLocation();

  if (location.pathname === '/' || location.pathname === '/pricing') {
    return <HomePage />;
  }

  if (isDemoRoute(location.pathname)) {
    return <DemoApp />;
  }

  return (
    <Suspense
      fallback={(
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        </div>
      )}
    >
      <AuthenticatedApp />
    </Suspense>
  );
}
